import React from "react";
import { Container, Typography, Box, List, ListItem } from "@mui/material";
import { useTranslation } from "react-i18next";

const Home: React.FC = () => {
  const { t } = useTranslation();
  // Ensure topics is always an array
  const topics = t("home.topics", { returnObjects: true }) as string[];

  const body1Sx = { color: "#000", fontSize: "20px", lineHeight: "36px" };
  const headingSx = { color: "#000" };

  return (
    <Container
      maxWidth="md"
      sx={{ py: 6, fontSize: { xs: "1.2rem", md: "1.35rem" } }}
    >
      {/* Top: Photo and Main Text */}
      <Box
        sx={{
          display: { xs: "block", md: "flex" },
          alignItems: "center",
          mb: 6,
        }}
      >
        <Box sx={{ flex: "0 0 40%", mb: { xs: 2, md: 0 }, mr: { md: 4 } }}>
          <Box
            component="img"
            src="/images/Lola-photo.jpg"
            alt="Lolita Papacosta"
            sx={{
              width: "100%",
              borderRadius: 2,
              objectFit: "cover",
              maxHeight: 400,
            }}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="h1" component="h1" gutterBottom sx={headingSx}>
            {t("home.title")}
          </Typography>
          <Typography
            variant="h2"
            component="h2"
            color="text.secondary"
            gutterBottom
            sx={headingSx}
          >
            {t("home.subtitle")}
          </Typography>
          <Typography variant="body1" paragraph sx={body1Sx}>
            {t("home.intro")}
          </Typography>
          <Typography variant="body1" paragraph sx={body1Sx}>
            {t("home.description")}
          </Typography>
        </Box>
      </Box>

      {/* Affiliation Section */}
      <Typography variant="h3" gutterBottom sx={{ ...headingSx, pt: 6 }}>
        {t("home.affiliationTitle")}
      </Typography>
      <Box sx={{ mb: 2 }}>
        <Box
          component="img"
          src="/images/seps-logo.png"
          alt="SEPS Logo"
          sx={{ width: 242, height: 117, mb: 1, objectFit: "contain" }}
        />
      </Box>

      {/* Education Section */}
      <Typography variant="h3" gutterBottom sx={{ ...headingSx, pt: 6 }}>
        {t("home.educationTitle")}
      </Typography>
      <Typography variant="body1" paragraph sx={body1Sx}>
        {t("home.education")}
      </Typography>
      {/* <Typography variant="body1" paragraph>
        {t("home.training")}
      </Typography> */}
      <Typography variant="body1" paragraph sx={body1Sx}>
        {t("home.approach")}
      </Typography>

      {/* Topics Section */}
      <Typography
        id="topics-section"
        variant="h3"
        gutterBottom
        sx={{ ...headingSx, pt: 6 }}
      >
        {t("home.topicsTitle")}
      </Typography>
      <List sx={{ mb: 2, pl: 0 }}>
        {topics.map((topic, idx) => (
          <ListItem
            key={idx}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              pl: 0,
              mb: 2,
              fontWeight: 500,
              fontSize: "20px",
              lineHeight: "36px",
              color: "#000",
              // Custom bullet
              "&::before": {
                content: '"•"',
                color: "#757575",
                fontSize: "1.5em",
                display: "inline-block",
                width: "1.2em",
                minWidth: "1.2em",
                marginRight: "0.5em",
                lineHeight: 1.1,
              },
            }}
          >
            <Typography
              component="span"
              variant="body1"
              sx={{
                fontWeight: 500,
                fontSize: "20px",
                lineHeight: "36px",
                color: "#000",
              }}
            >
              {topic}
            </Typography>
          </ListItem>
        ))}
      </List>
      <Typography variant="body1" paragraph sx={body1Sx}>
        {t("home.sessionInfo")}
      </Typography>

      <Typography
        variant="body1"
        sx={{ ...body1Sx, fontWeight: 700, mt: 4 }}
      >
        {t("home.legalNotice")}
      </Typography>

      {/* Fees Section */}
      <Typography
        id="fees"
        variant="h3"
        gutterBottom
        sx={{ ...headingSx, pt: 6 }}
      >
        {t("home.feesTitle")}
      </Typography>
      <Typography
        variant="body1"
        sx={{ ...body1Sx, whiteSpace: "pre-line", mb: 2 }}
      >
        {t("home.fees")}
      </Typography>

      <Typography variant="body1" paragraph sx={body1Sx}>
        {t("home.cancellation")}
      </Typography>

      {/* Contact Section */}
      <Typography
        id="contact"
        variant="h3"
        gutterBottom
        sx={{ ...headingSx, pt: 6 }}
      >
        {t("home.contactTitle")}
      </Typography>
      <Typography variant="body1" paragraph sx={body1Sx}>
        {t("home.contact")}
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "start", mt: 6, mb: 4 }}>
        <iframe
          title="Lolita Papacosta Office Location"
          src="https://www.google.com/maps?q=Ithaki+Mansions,+Kerkiras+19-apt.+B+12,+Limassol+3107&output=embed"
          width="600"
          height="450"
          style={{ border: 0, borderRadius: 8, maxWidth: "100%" }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </Box>
    </Container>
  );
};

export default Home;
